import { createAccount } from '@/common/lib/api'
import { toUnderscore } from '@/common/lib/case-parser'

function mountData(personType, owner, company, address, partnerId, campaignId) {
  if (personType === 'PJ') {
    const data = {
      ...company,
      personType,
      nickname: company.tradingName,
      owner,
      address,
      partnerId,
      campaignId
    }

    delete data.tradingName

    return data
  }

  const data = {
    ...owner,
    personType,
    address,
    partnerId,
    campaignId,
    owner: {
      password: owner.password,
      passwordConfirm: owner.passwordConfirm
    }
  }

  data.cellPhone = data.phone

  delete data.phone
  delete data.password
  delete data.passwordConfirm

  return data
}

export default async function register(
  personType,
  company,
  owner,
  address,
  partnerId = null,
  campaignId = null,
  authorization = null
) {
  try {
    const data = toUnderscore(mountData(personType, owner, company, address, partnerId, campaignId))
    return createAccount(authorization, data)
  } catch (e) {
    return false
  }
}
